import React from 'react';
import { Board } from './styles';

const Component = ({ children, scale, board }: any) => {
  return <>
    <Board
      id="board"
      width={board.width * scale}
      height={board.height * scale}
      scale={scale}
      board={board.name}
    >
      <div className="border">
        <div className="bigshadow" />
        <div className="bigshadow" />
      </div>
      {children}
    </Board>
  </>
}

export default Component;
